import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PageShell from "components/bento/PageShell";
import TabsNavigator from "components/TabsNavigator";
import CreateTab from "./CreateTab";
import HistoryTab from "./HistoryTab";

const DepartureBatch = () => {
  const { t } = useTranslation();
  // Bumped whenever the History tab clears/cancels items on a batch, so the
  // Create tab's candidate list picks up newly-available packages. Tabs stay
  // mounted under TabsNavigator (TabPanel), so this can't rely on remount.
  const [refreshSignal, setRefreshSignal] = useState(0);

  const tabItems = [
    { text: t("departureBatch.tabCreate"), component: <CreateTab refreshSignal={refreshSignal} /> },
    {
      text: t("departureBatch.tabHistory"),
      component: <HistoryTab onItemsChanged={() => setRefreshSignal((n) => n + 1)} />,
    },
  ];

  return (
    <PageShell title={t("departureBatch.title")} subtitle={t("departureBatch.subtitle")}>
      <TabsNavigator tabItems={tabItems} />
    </PageShell>
  );
};

export default DepartureBatch;
